<template>
  <div>
    <ed-table
    :key="$root.$session.versao"
      strModel="Audiometria/Audiometro"
      :headers="arrayHeaders"
      :rows="arrayRows"
      :pagination="objPagination"
      :filter="formFiltros"
      :loading="loading"
      @register="onRegister"
      @edit="onEdit"
      @search="getAudiometro"
    />
  </div>
</template>

<script>
import { EdTable } from "@/components/common/form";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdTable },
  mounted() {
    this.getAudiometro();
  },
  beforeDestroy() {
    this.arrayHeaders = [];
    this.arrayRows = [];
    this.objPagination = null;
  },
  created() {},
  data() {
    return {
      loading: false,
      arrayHeaders: [
        {
          text: "Equipamento",
          sortable: true,
          value: "strNome",
        },
        {
          text: "Modelo",
          sortable: true,
          value: "strModelo",
        },
        {
          text: "Fabricante",
          sortable: true,
          value: "strFabricante",
        },
        {
          text: "Última Caligragem",
          sortable: true,
          value: "strDataUltimaCalibragem",
        },
      ],
      arrayRows: [],
      objPagination: null,
      formFiltros:{}
    };
  },
  methods: {
    onRegister() {
      this.$router.push({ name: "audiometria.audiometro.register" });
    },

    onEdit(data) {
      this.$router.push({
        name: "audiometria.audiometro.edit",
        params: { intId: data.intId },
      });
    },

    getAudiometro() {
      this.loading = true;
      this.arrayRows = [];

      this.$root.$request.get("Audiometria/Audiometro", this.formFiltros).then((objResult) => {
        if (objResult.status == 200) {
          this.objPagination = objResult.result;
          this.loading = false;

          objResult.result.data.forEach((objCovenio) => {
            let item = {
              intId: objCovenio.intId,
              strNome: objCovenio.strNome,
              strModelo: objCovenio.strModelo,
              strFabricante: objCovenio.strFabricante,
              strDataUltimaCalibragem: objCovenio.strDataUltimaCalibragem ? this.$utilidade.toDate(objCovenio.strDataUltimaCalibragem,true) : '---',
              _item: objCovenio,
            };

            this.arrayRows.push(item);
          });
        }
      });
    },
  },
};
</script>
